import * as React from 'react';
import { SVGProps } from 'react';

const IconResizeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.393 18.536 18.535 4.393l1.415 1.415L5.808 19.95l-1.415-1.414zm5.657 0 8.485-8.486 1.415 1.414-8.486 8.486-1.414-1.414zm9.9-1.415-1.415-1.414-2.828 2.829 1.414 1.414 2.829-2.829z" />
  </svg>
);
export default IconResizeSizeM;
